export const ROOM_ERROR_TYPES = {
  RECREATING_ROOM: 'RECREATING_ROOM',
  RECREATE_SUCCESS: 'RECREATE_SUCCESS',
  APPOINTMENT_CANCELLED: 'APPOINTMENT_CANCELLED',
  APPOINTMENT_NOT_FOUND: 'APPOINTMENT_NOT_FOUND',
  APPOINTMENT_ENDED_PATIENT: 'APPOINTMENT_ENDED_PATIENT',
  APPOINTMENT_ENDED_PROVIDER: 'APPOINTMENT_ENDED_PROVIDER',
  RECREATE_FAILED: 'RECREATE_FAILED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type RoomErrorType =
  (typeof ROOM_ERROR_TYPES)[keyof typeof ROOM_ERROR_TYPES];

export type RoomErrorState =
  | { type: typeof ROOM_ERROR_TYPES.RECREATING_ROOM }
  | { type: typeof ROOM_ERROR_TYPES.RECREATE_SUCCESS }
  | { type: typeof ROOM_ERROR_TYPES.APPOINTMENT_CANCELLED }
  | { type: typeof ROOM_ERROR_TYPES.APPOINTMENT_NOT_FOUND }
  | { type: typeof ROOM_ERROR_TYPES.APPOINTMENT_ENDED_PATIENT }
  | { type: typeof ROOM_ERROR_TYPES.APPOINTMENT_ENDED_PROVIDER }
  | { type: typeof ROOM_ERROR_TYPES.RECREATE_FAILED; message: string }
  | { type: typeof ROOM_ERROR_TYPES.UNKNOWN_ERROR; message: string };

export interface RoomErrorScreenProps {
  state: RoomErrorState;
  onReload?: () => void;
}
